import React from 'react';
import {ScrollView, StyleSheet} from 'react-native';
import {observer} from 'mobx-react-lite';

import NoTillPaymentServiceAvailableModal from '../../components/modals/NoPaymentConfiguredModal';
import CardTokeniserTillModal from '../../components/payments/till/cardTokeniser/CardTokeniserTillModal';
import {AccountPaymentMethodCard} from '../../components/payments/till/PaymentMethodSelector';
import ContentView from '../../components/ui-controls/layout/ContentView';
import {AppRoute} from '../../models/AppRoute';
import {RouteNavigatorScreenProps} from '../../models/navigationTypes';
import {useCardManagement} from '../cart/hooks';

const PaymentMethodScreen = observer(
  (_: RouteNavigatorScreenProps<AppRoute.ACCOUNT_PAYMENT_METHOD>) => {
    // Card management via consolidated hook (fetches via TanStack Query)
    const {
      handleAddOrChangeCard,
      handleDeleteCard,
      isCardTokeniserModalVisible,
      setCardTokeniserModalVisible,
      isNoPaymentServiceModalVisible,
      setNoPaymentServiceModalVisible,
    } = useCardManagement();

    return (
      <ContentView>
        <ScrollView contentContainerStyle={styles.main}>
          <AccountPaymentMethodCard
            onAddCard={handleAddOrChangeCard}
            onChangeCard={handleAddOrChangeCard}
            onDeleteCard={handleDeleteCard}
          />
        </ScrollView>
        <CardTokeniserTillModal
          isVisible={isCardTokeniserModalVisible}
          onCancel={() => setCardTokeniserModalVisible(false)}
          navigationTarget={AppRoute.ACCOUNT_PAYMENT_METHOD}
        />
        <NoTillPaymentServiceAvailableModal
          onOK={() => setNoPaymentServiceModalVisible(false)}
          isVisible={isNoPaymentServiceModalVisible}
        />
      </ContentView>
    );
  },
);

export default PaymentMethodScreen;

const styles = StyleSheet.create({
  main: {
    flex: 1,
    alignItems: 'stretch',
    justifyContent: 'center',
    zIndex: 50,
  },
});
